export class ChannelService {
    constructor(channelIds, container) {
        this.container = container;
        const actualChannelIds = Array.isArray(channelIds)
            ? channelIds
            : [channelIds];
        if (actualChannelIds.length > 1) {
            const actualChannelId = this.container.createMultiChannel(actualChannelIds);
            this._channelId = actualChannelId;
        }
        else {
            this._channelId = actualChannelIds[0];
        }
    }
    /**
     *
     * @param channelIds all channel ids will be merged to a single channel and that will be selected for this channel service.
     */
    tune(...channelIds) {
        return new ChannelService(channelIds, this.container);
    }
    get() {
        return this.container.get(this._channelId);
    }
    set(message) {
        this.container.set(this._channelId, message);
    }
    listen(listener) {
        return this.container.addListener(this._channelId, listener);
    }
    cleanUp() {
        this.container.cleanUp(this._channelId);
    }
}
